import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TimePicker = (props) => {
    return (_jsxs("div", { className: "form-group", children: [_jsx("label", { children: "Effective To Time:" }), _jsx("div", { className: "input-group", children: _jsx("input", { type: "time", step: "1", value: props.time, onChange: props.onChange, className: "form-control" }) })] }));
};
export default TimePicker;
